module.exports = __webpack_public_path__ + "img/fb77aee.png";